var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gridBox",class:_vm.columns ? 'gridBox__row' : 'gridBox__column',style:(_vm.columns ? {'grid-template-columns': `repeat(${_vm.columns}, minmax(0, 1fr))`} : {'grid-template-rows': `repeat(${_vm.rows}, minmax(0, 1fr))`})},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }